import Component from '../abstracts/Component';

export default class NotifyMeBtnComponent extends Component {

  get SELECTORS() {
    return {
      main: '.c-p-n__submit',
    };
  }

  constructor() {
    super();
  }
  
  initTrigger(){
      let buttons = document.querySelectorAll(this.SELECTORS.main);
      for(let btn of buttons){
        this.$on(this.$customEvents.NOTIFY_ME_STATE.sent,()=>{
          btn.classList.add('sent');
          setTimeout(()=>{
            btn.classList.remove('sent');
          },1000);
        })
      }
  }
  render() {
    
    if(document.querySelector(this.SELECTORS.main)){
      this.initTrigger();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
